import React from 'react';
import { useNavigate } from 'react-router-dom';

function TableContent({ headers, vehicles }) {
  const navigate = useNavigate();
  const paddingMode = localStorage.getItem('paddingMode') || 'comfy';

  const handleVehicleNumberClick = (vehicleId) => {
    if (vehicleId) {
      navigate(`/vehicle/${vehicleId}`);
    }
  };

  return (
    <tbody>
      {vehicles?.length > 0 ? (
        vehicles.map((vehicle) => (
          <tr key={vehicle.id}>
            {headers.map((header, index) => (
              <td
                className={`table-data ${
                  paddingMode === 'compact'
                    ? 'compact-padding'
                    : 'comfortable-padding'
                }`}
                key={header.value}
              >
                <div className="div-flex-row div-align-center cg-5">
                  {index === 0 && (
                    <input type="checkbox" className="checkbox-grey" />
                  )}
                  {header.value === 'vehicle_number' ? (
                    <button
                      type="button"
                      className="vehicle-master-link-button text-sm-outfit text-medium-bold"
                      onClick={() => handleVehicleNumberClick(vehicle.id)}
                    >
                      {vehicle[header.value] ?? '-'}
                    </button>
                  ) : (
                    <span>{vehicle[header.value] ?? '-'}</span>
                  )}
                </div>
              </td>
            ))}
          </tr>
        ))
      ) : (
        <div className="no-list-data-message border-bottom">
          <span className="text-sm">No Vehicle Found</span>
        </div>
      )}
    </tbody>
  );
}

export default TableContent;
